import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

declare global {
  let PROFILE: string;
  let API_URL: string;
  let AUTH0_DOMAIN: string;
  let AUTH0_CLIENT_ID: string;
  let AUTH0_AUDIENCE: string;
  let AUTH0_SCOPE: string;
  let AUTH0_REDIRECT_URI: string;
}
